/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditornodishes3Inputs */

const en_menueditornodishes3 = /** @type {(inputs: Menueditornodishes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No dishes yet.`)
};

const de_menueditornodishes3 = /** @type {(inputs: Menueditornodishes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Gerichte.`)
};

/**
* | output |
* | --- |
* | "No dishes yet." |
*
* @param {Menueditornodishes3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditornodishes3 = /** @type {((inputs?: Menueditornodishes3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditornodishes3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditornodishes3(inputs)
	return de_menueditornodishes3(inputs)
});
export { menueditornodishes3 as "menuEditorNoDishes" }